// Campus photo for /colleges/colby-college: CC0 1.0, by Communications and Engagement, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AColby_College_Museum_of_Art_2024.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/colby-college/; credited under the photo.
const photo = {
    "slug": "colby-college",
    "alt": "The glass pavilion of the Colby College Museum of Art and its red Colby Museum sign, in Waterville, Maine",
    "src": "/colleges/colby-college/campus-1600.webp",
    "srcSmall": "/colleges/colby-college/campus-800.webp",
    "srcMid": "/colleges/colby-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/colby-college/og.jpg",
    "title": "Colby College Museum of Art 2024",
    "author": "Communications and Engagement",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AColby_College_Museum_of_Art_2024.jpg",
    "read": "2026-10-01"
};

export default photo;
